import request from '../../utils/request';

function instantiateExistingRutLegalPersonEnrollment(payload) {
  return request({
    method: 'POST',
    url: '/legal-person-enrollment/initialize/new',
    data: payload,
  });
}
// COMENTARIO
function resendInstantiationEmail(token) {
  return request({
    method: 'GET',
    url: `/auth/resend-verification-mail/${token}`,
  });
}

function validateMail(token, code) {
  return request({
    method: 'POST',
    url: '/validate',
    data: {
      token,
      code,
    },
  });
}

export default {
  instantiateExistingRutLegalPersonEnrollment,
  resendInstantiationEmail,
  validateMail,
};
